import request from '@/utils/httpRequest'

export default class MarchIntoService {
    queryById (id) {
        return request({
            url: '/shye/contract/shyeMarchInto/queryById',
            method: 'get',
            params: {id: id}
        })
    }

    startFlow (params) {
        return request({
            url: '/shye/contract/shyeMarchInto/startFlow',
            method: 'post',
            data: params
        })
    }
}
